<template>
  <div>
    <Head title="REEM Registrations" />
    <form @submit.prevent="store">
      <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <h1 style="width: 100%;" class="w-100 mt-6 pb-10 text-3xl font-bold">
              <Link class="text-indigo-400 hover:text-indigo-600" href="/reem"><small>Back</small></Link>
              <span class="text-indigo-400 font-medium"> |</span> New Energy Manager Registration
              <span v-if="managers_id !== 'draft'" class="text-indigo-200 ml-8"><small>Draft Saved</small></span>
            </h1>        
            
            <loading-button :loading="form.processing" class="btn-indigo px-6 py-4" type="submit">
              💾&nbsp;Save as Draft
            </loading-button>
        </div>       
      
    <div class="bg-white rounded-md shadow overflow-hidden pt-6">     
        <form-wizard step-size="xs" @on-complete="onComplete" ref="wizard">
          <tab-content title="Bahagian A : Maklumat Pemohon">
            
            <div class="flex items-center justify-between mt-6">
              <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
                👤 <span class="text-indigo-600">Maklumat Pemohon</span>
              </h1>
            </div>


              <div class="relative block p-4">
                <AvatarInput v-model="form.photo" :default-src="photo" class="w-48 h-48 rounded-full ml-auto mr-auto"/>
              </div> 
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <select-input v-model="form.category" :error="form.errors.category" class="pb-8 pr-6 w-full lg:w-1/2" label="Jenis Permohonan ">
                <option :value="null" />
                  <option value="temuduga">Temuduga Professional</option>
                  <option value="kursus">Enakmen Bekalan Elektrik 2024 & EMEER 2024</option>
              </select-input>
              <text-input required v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" label="*Nama Pengadu " />
              <text-input v-model="form.ic_no" :error="form.errors.ic_no" class="pb-8 pr-6 w-full lg:w-1/2" label="No. MyKad " />
              <file-input v-model="form.ic_copy" :error="form.errors.ic_copy" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="application/pdf" label="*📎 Salinan Kad Pengenalan Pemohon - Depan & Belakang (pdf)" />  
              <text-input v-model="form.id_no" :error="form.errors.id_no" class="pb-8 pr-6 w-full lg:w-1/2" label="No Pengenalan Lain (cth. Passport) " />
              <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/2" label="Jenis Pengurus Tenaga ">
                  <option :value="null" />
                  <option value="terhad">Terhad</option>
                  <option value="terbuka">Terbuka</option>
              </select-input> 
              <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.birthday"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Lahir"></Datepicker>
              <select-input v-model="form.gender" :error="form.errors.gender" class="pb-8 pr-6 w-full lg:w-1/2" label="Jantina ">
                  <option :value="null" />
                  <option value="M">Lelaki</option>
                  <option value="F">Perempuan</option>
              </select-input> 
              <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full" label="Alamat " />
              <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full" label="Bandar " />
              <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Poskod " />
              <text-input v-model="form.region" :error="form.errors.region" class="pb-8 pr-6 w-full lg:w-1/2" label="Negeri " />

              <text-input v-model="form.mail_address" :error="form.errors.mail_address" class="pb-8 pr-6 w-full" label="Alamat Surat Menyurat " />
              <text-input v-model="form.mail_city" :error="form.errors.mail_city" class="pb-8 pr-6 w-full" label="Bandar " />
              <text-input v-model="form.mail_poscode" :error="form.errors.mail_poscode" class="pb-8 pr-6 w-full lg:w-1/2" label="Poskod " />
              <text-input v-model="form.mail_state" :error="form.errors.mail_state" class="pb-8 pr-6 w-full lg:w-1/2" label="Negeri " />
  
              <text-input v-model="form.phone_no" :error="form.errors.premise_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Telefon " />
              <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Telefon (HP) " />
              <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Alamat Email " />
              
            </div>
        </tab-content>
        <tab-content title="Bahagian B : Maklumat Majikan Dan Pekerjaan">

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              🏢 <span class="text-indigo-600">Maklumat Majikan Dan Pekerjaan</span>
            </h1>
          </div>


          <div class="flex flex-wrap -mb-8 -mr-6 p-8">           

              <text-input required v-model="form.company_name" :error="form.errors.company_name" class="pb-8 pr-6 w-full" label="*Nama Majikan " />
              <text-input v-model="form.company_address" :error="form.errors.company_address" class="pb-8 pr-6 w-full" label="Alamat Majikan " />
              
              <text-input v-model="form.company_city" :error="form.errors.company_city" class="pb-8 pr-6 w-full" label="Bandar " />
              <text-input v-model="form.company_poscode" :error="form.errors.company_poscode" class="pb-8 pr-6 w-full lg:w-1/2" label="Poskod " />
              <text-input v-model="form.company_state" :error="form.errors.company_state" class="pb-8 pr-6 w-full lg:w-1/2" label="Negeri " />
  

              <text-input v-model="form.company_phone" :error="form.errors.company_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Telefon " />
              <text-input v-model="form.company_fax" :error="form.errors.company_fax" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Fax " />
              
              <text-input v-model="form.website" :error="form.errors.website" class="pb-8 pr-6 w-full" label="Alamat Laman Web " />
              <text-input v-model="form.position" :error="form.errors.position" class="pb-8 pr-6 w-full lg:w-1/2" label="Jawatan Terkini " />
                  
          </div>

        </tab-content>
        <tab-content title="Bahagian C : Kelayakan Pemohon">

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              🏢 <span class="text-indigo-600">Kelayakan Professional</span>
            </h1>
          </div>
          
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">           
            <text-input v-model="form.my_engineering_register" :error="form.errors.my_engineering_register" class="pb-8 pr-6 w-full" label="No. Pendaftaran Jurutera Profesional " />
            <text-input v-model="form.my_engineering_reff" :error="form.errors.my_engineering_reff" class="pb-8 pr-6 w-full" label="No. resit pembaharuan pendaftaran dengan Lembaga Jurutera Malaysia yang terkini (tahun semasa) " />
          </div>

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              📃 <span class="text-indigo-600">Perakuan Kekompetenan oleh ECoS / ST sedia ada</span>
            </h1>
            <a class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formCompetentPerson">
              <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
            </a> 
          </div>
          
          <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6 text-center">Perakuan Kekompetenan</th>
                <th class="pb-4 pt-6 px-6 text-center">Sekatan</th>
                <th class="pb-4 pt-6 px-6 text-center">No. Perakuan</th>
                <th class="pb-4 pt-6 px-6 text-center">Tarikh Dikeluarkan</th>
                <th class="pb-4 pt-6 px-6 text-center">Action</th>
              </tr>
              <tr v-for="competent in competents" :key="competent.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t py-2 pb-2 pl-6">
                    <span class="flex">{{ competent.name }}</span>
                    <icon v-if="competent.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </td>
                <td class="border-t">
                  <span>{{ competent.certificate }}</span>     
                </td>
                <td class="border-t text-center">
                  <span>{{ competent.ic_no }}</span>  
                      <!-- <a class="cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" target="_blank" :href="attachment.attachment">
                        <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                        View File 
                      </a>                 -->               
                </td>
                <td class="border-t">
                  <span>{{ competent.certificate }}</span>     
                </td>
                <td class="border-t text-center">
                  <center>
                  <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadCompetent(competent)">
                    <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Edit 
                  </a>                
                  </center>                      
                </td>
              </tr>
              <tr v-if="competents.length === 0">
                <td class="px-6 py-4 border-t" colspan="5">
                  <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    Tiada orang kompetent.&nbsp;&nbsp;
                    <a class="cursor-pointer text-indigo-500" @click="formCompetentPerson()">
                      <strong>Tambah rekod</strong>
                    </a>
                  </span>               
                </td>
              </tr>
            </table>
          </div>

          <div class="flex items-center justify-between mt-6">
                <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
                  📜 <span class="text-indigo-600">Kelayakan Akademik</span>
                </h1>
                <a class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formAcedemics">
                  <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
                </a> 
              </div>
              
              <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
                <table class="w-full whitespace-nowrap">
                  <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6 text-center">Nama Ijazah/Kelulusan yang setaraf</th>  
                    <th class="pb-4 pt-6 px-6 text-center">Nama Institusi/Universiti</th>
                    <th class="pb-4 pt-6 px-6 text-center">Tarikh Lulus</th>
                    <th class="pb-4 pt-6 px-6 text-center">Action</th>
                  </tr>
                  <tr v-for="academic in academics" :key="academic.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t py-2 pb-2 pl-6">
                      <span class="flex">{{ academic.name }}</span>
                      <icon v-if="academic.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                    </td>
                    <td class="border-t text-center">
                      <span>{{ academic.course }}</span>   
                    </td>
                    <td class="border-t text-center">
                      <span>{{ academic.cert_date }}</span>  
                    </td>
                    <td class="border-t text-center">
                      <center>
                      <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadAcademic(academic)">
                        <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                        Edit 
                      </a>                
                      </center>                      
                    </td>
                    <!-- <td v-if="form.owner" class="border-t text-center">
                      ..
                    </td> -->
                  </tr>
                  <tr v-if="academics.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">
                      <span class="flex justify-center py-2">
                        <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                        Tiada rekod akademik.&nbsp;&nbsp;
                        <a class="cursor-pointer text-indigo-500" @click="formAcedemics()">
                          <strong>Tambah rekod</strong>
                        </a>
                      </span>               
                    </td>
                  </tr>
                </table>
              </div>


        </tab-content>
        <tab-content title="Bahagian D :  Rekod Pengalaman Kerja Pemohon">

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              🗃 <span class="text-indigo-600">Rekod Pengalaman Kerja</span>
            </h1>
            <a class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formExperiences">
              <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
            </a> 
          </div>

          <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6 text-center">Nama Majikan</th>
                <th class="pb-4 pt-6 px-6 text-center">Alamat Majikan</th>
                <th class="pb-4 pt-6 px-6 text-center">Jawatan</th>
                <th class="pb-4 pt-6 px-6 text-center">Bidang Tugas</th>
                <th class="pb-4 pt-6 px-6 text-center">Tarikh Mula</th>
                <th class="pb-4 pt-6 px-6 text-center">Action</th>
              </tr>
              <tr v-for="experience in experiences" :key="experience.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t pl-4">
                  <span class="flex">{{ experience.name }}</span>
                  <icon v-if="experience.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </td>
                <td class="border-t py-2 pb-2 pl-6">
                  <span class="flex">{{ experience.address }}</span>  
                </td>
                <td class="border-t text-center">                
                  <span class="flex">{{ experience.position }}</span>  
                </td>
                <td class="border-t text-center">
                  <span class="flex">{{ experience.jobs }}</span>  
                </td>
                <td class="border-t text-center">
                  <span class="flex">{{ experience.start_date }}</span>  
                </td>
                <td class="border-t text-center">
                  <center>
                  <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadExperience(experience)">
                    <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Edit 
                  </a>                
                  </center>                      
                </td>
              </tr>
              <tr v-if="experiences.length === 0">
                <td class="px-6 py-4 border-t" colspan="6">
                  <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    Tiada rekod pengalaman kerja.&nbsp;&nbsp;
                    <a class="cursor-pointer text-indigo-500" @click="formExperiences()">
                      <strong>Tambah rekod</strong>
                    </a>
                  </span>               
                </td>
              </tr>
            </table>
          </div>           

          
        </tab-content>


        <tab-content title="Bahagian E :  Pengalaman Kerja Pemohon Dalam Pengurusan Tenaga Elektrik Dengan Cekap">

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              🗃 <span class="text-indigo-600">Pengalaman Kerja Pemohon Dalam Pengurusan Tenaga Elektrik Dengan Cekap</span>
            </h1>
          </div>

          <div class="flex flex-wrap mb-8 mr-6 p-8">

          <p class="text-lg">(i) Tugas-tugas Berkenaan Pengurusan Tenaga Elektrik dengan Cekap Yang Pernah Dilaksanakan</p>
          <p class="text-lg pt-4">Sila terangkan dengan terperinci tentang tugas-tugas pengurusan tenaga elektrik dengan cekap yang dilaksanakan di 
            <a href="/Lampiran-A.pdf" target="_blank">Lampiran A</a>
          </p>
          <p class="text-lg pt-12">(ii) Laporan Projek/Tugas Berkenaan Pengurusan Tenaga Elektrik dengan Cekap</p>
          <p class="text-lg pt-4">Sila sediakan dan sertakan laporan lengkap mengenai projek/tugas yang ada terlibat berkenaan pengurusan tenaga elektrik dengan cekap seperti panduan berikut:-</p>

          <p class="text-lg pt-4">a) Nama dan penerangan projek;</p>

          <p class="text-lg pt-4">b) Senarai nama mereka yang terlibat,jawatan dan peranan masing-masing;</p>

          <p class="text-lg pt-4">c) Penerangan kajian awal (feasibility study)/audit tenaga yang dilakukan;</p>

          <p class="text-lg pt-4">d) Prinsip/kaedah/aplikasi/teknologi kecekapan tenaga yang digunakan;</p>

          <p class="text-lg pt-4">e) Senarai potensi penjimatan tenaga dan kaedah pegiraan potensi penjimatan tenaga dalam unit tenaga;</p>

          <p class="text-lg pt-4">f) Kaedah pengukuran dan pengiraan kuantiti penjimatan tenaga yang dicapai; dan</p>

          <p class="text-lg pt-4">g) Senarai langkah-langkah yang diambil dan aktiviti-aktiviti utama yang terlibat bersama tempoh masa setiap langkah dan aktiviti berkenaan dilaksanakan daripada mula hingga penjimatan tenaga dicapai;</p>

          <p class="text-lg pt-4">h) Analisa kewangan ringkas seperti Simple Payback Period, Return of Investment dan sebagainya.</p>

          <p class="text-lg pt-12">Panduan format laporan</p>


          <p class="text-lg pt-4">Laporan mesti ditaip dengan menggunakan kertas A4</p>
          <p class="text-lg pt-4">Bahasa penulisan: Bahasa Melayu atau Bahasa Inggeris.</p>
          <p class="text-lg pt-4">Jenis Tulisan: Times New Roman/Arial; saiz:12; Selangan:1.5</p>

          <p class="text-lg pt-4">(Sila sertakan surat pengesahan daripada majikan/wakil pepasangan yang di mana projek/tugas tersebut telah dijalankan)</p>

          <p class="text-lg pt-12">(iii)  Latihan/Kursus Berkaitan Kecekapan Tenaga Yang Pernah Disertai</p>

          </div>

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              📜 <span class="text-indigo-600">Latihan/Kursus Berkaitan Kecekapan Tenaga</span>
            </h1>
            <a class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formCourses">
              <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
            </a> 
          </div>
                
          <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6 text-center">Nama Kursus</th>  
                <th class="pb-4 pt-6 px-6 text-center">Skop/Bidang Topik Kecekapan Tenaga</th>
                <th class="pb-4 pt-6 px-6 text-center">Tahun Kursus</th>
                <th class="pb-4 pt-6 px-6 text-center">tempoh Kursus</th>
                <th class="pb-4 pt-6 px-6 text-center">Organisasi Penyelia Kursus</th>
                <th class="pb-4 pt-6 px-6 text-center">Lain-lain Organisasi</th>
                <th class="pb-4 pt-6 px-6 text-center">Action</th>
              </tr>
              <tr v-for="course in courses" :key="course.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t py-2 pb-2 pl-6">
                  <span class="flex">{{ course.name }}</span>
                  <icon v-if="course.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </td>
                <td class="border-t text-center">
                  <span>{{ course.course }}</span>   
                </td>
                <td class="border-t text-center">
                  <span>{{ course.year }}</span>  
                </td>
                <td class="border-t text-center">
                  <span>{{ course.duration }}</span>  
                </td>
                <td class="border-t text-center">
                  <span>{{ course.organizer }}</span>  
                </td>
                <td class="border-t text-center">
                  <span>{{ course.others }}</span>  
                </td>
                <td class="border-t text-center">
                  <center>
                  <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadCourses(course)">
                    <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Edit 
                  </a>                
                  </center>                      
                </td>
                <!-- <td v-if="form.owner" class="border-t text-center">
                  ..
                </td> -->
              </tr>
              <tr v-if="courses.length === 0">
                <td class="px-6 py-4 border-t" colspan="7">
                  <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    Tiada rekod kursus.&nbsp;&nbsp;
                    <a class="cursor-pointer text-indigo-500" @click="formCourses()">
                      <strong>Tambah rekod</strong>
                    </a>
                  </span>               
                </td>
              </tr>
            </table>
          </div>

          <textarea-input style="height: 24vh;" v-model="form.field_knowledge" :error="form.errors.field_knowledge" class="pb-8 w-full" label="Bidang Pengetahuan dan Kelayakan Khusus Yang Dimiliki Dalam Pengurusan Tenaga Elektrik Dengan Cekap" />

          </tab-content>


        <tab-content title="Bahagian F : Rujukan">

            <div class="flex items-center justify-between mt-6">
              <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
                ✒️ <span class="text-indigo-600">Rujukan</span>
              </h1>
            </div>

            <span style="width: 100%;" class="pb-16 pr-12 flex items-center" ref="status">
              <span class="text-xl px-8">Sila nyatakan pihak yang boleh dirujuk oleh ECoS berkenaan pengalaman kerja atau tugas-tugas berkaitan pengurusan tenaga elektrik dengan cekap yang telah dilaksanakan.</span>             
            </span> 

            <div class="flex flex-wrap -mb-8 -mr-6 p-8">           

              <text-input v-model="form.referral_name" :error="form.errors.referral_name" class="pb-8 pr-6 w-full" label="*Nama " />
              <text-input v-model="form.referral_organization" :error="form.errors.referral_organization" class="pb-8 pr-6 w-full" label="Organisasi " />

              <text-input v-model="form.referral_position" :error="form.errors.referral_position" class="pb-8 pr-6 w-full" label="Jawatan " />
              <text-input v-model="form.referral_phone" :error="form.errors.referral_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="*No. Telefon " />
              <text-input v-model="form.referral_fax" :error="form.errors.referral_fax" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Fax " />


              <text-input v-model="form.referral_email" :error="form.errors.referral_email" class="pb-8 pr-6 w-full lg:w-1/2" label="*Alamat Email " />
                  
              </div>

        
        </tab-content>

        <tab-content title="Bahagian G : Dokumen Sokongan (Muat Naik)">

        <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-4 text-2xl font-bold">
              📄 <span class="text-indigo-600">Muat Naik Dokumen Sokongan</span>
            </h1>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen (pdf format)</th>
            </tr>
            <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-l border-t border-b pl-4">
                <a href="/Lampiran-A.pdf" target="_blank">Lampiran A</a> (Penerangan terperinci tentang tugas-tugas pengurusan tenaga elektrik dengan cekap yang dilaksanakan)
              </td>
              <td class="border-t border-b border-r">
                <file-input v-model="form.lampiran_a" :error="form.errors.lampiran_a" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Lampiran A (pdf)" />
              </td>             
            </tr>
            
          </table>
        </div> 
        
        <div class="flex mt-6">
            <h1 class="pl-8 w-100 pb-4 text-xl font-bold">
              <span class="text-indigo-600">Sila aktifkan/<span style="font-style:italic">toggle button</span> kepada dokumen sokongan berikut yang akan dihantar kepada ECoS untuk proses semakan permohonan. Proses permohonan adalah tertakluk kepada penerimaan dokumen-dokumen sokongan seperti di senarai berikut:</span>
            </h1>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen</th>
            </tr>
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">
                Bayaran Fi
                <ol class="ml-4">
                  <li class="pt-2 pb-2">- Permohonan untuk pendaftaran sebagai pengurus tenaga elektrik RM 200.00 setiap permohonan.</li>
                  <li class="pb-2">- Pengeluaran Perakuan pendaftaran RM250.00 setahun.</li>
                </ol>
              </td>
              <td class="pb-4 pt-6 px-6 text-center">
                <file-input v-if="!resit_pembayaran_upload" v-model="form.resit_pembayaran" :error="form.errors.resit_pembayaran" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Resit Pembayaran (pdf)" />
              </td>
            </tr>
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Gambar berukuran passport (*jpg, *png) (Latar Belakang Biru)
                <!-- <ol class="ml-4">
                  <li class="pt-2 pb-2">- Kertas gambar tidak berkilat (gambar bukan instant).</li>
                  <li class="pb-2">- Calon memakai baju kemeja atau t-shirt berkolar (t-shirt berleher bulat tidak dibenarkan).</li>
                  <li class="pb-2">- Gambar yang tidak berukuran passport atau tidak menepati piawai tidak akan diterima.</li>
                </ol> -->
              </td>
              <td class="pb-4 pt-6 px-6 text-center">
                <file-input v-if="!passport_photo_upload" v-model="form.passport_photo" :error="form.errors.passport_photo" class="py-2 w-full" type="file" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" label="*📎 Gambar Berukuran Passport (*jpg, *jpeg, *png)" /> 
              </td>
            </tr>
            <!-- <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Satu salinan K.P (depan dan belakang)yang disahkan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton 
                  class="float-right"
                    v-model="form.has_id" 
                    @on-change="toggleIdentified"
                    :is-active="isIdentified(has_id)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton> 
              </td>
            </tr>
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Salinan Ijazah/kelulusan setaraf yang disahkan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton 
                  class="float-right"
                    v-model="form.has_qualification" 
                    @on-change="toggleQualification"
                    :is-active="isQualified(has_qualification)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton> 
              </td>
            </tr>              -->
          </table>
        </div>

        <div class="flex mt-6">
            <h1 class="pl-8 w-100 pb-4 text-xl font-bold">
              <span class="text-indigo-600">Bagi pemohon yang memperolehi ijazah daripada institusi luar negara/institusi pendidikan swasta(IPTS), sila pastikan ijazah tersebut telah mendapat pengiktirafan / akreditasi daripada Kementerian Pendidikan Tinggi (KPT) / Jabatan Perkhidmatan Awam (JPA) / Agensi Kelayakan Malaysia (MQA) / Badan Profesional yang diiktiraf kerajaan Malaysia (BEM).</span>
            </h1>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen</th>
            </tr>
            <!-- <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Salinan Perakuan Kekompetenan ECoS yang sedia ada yang disahkan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton 
                  class="float-right"
                    v-model="form.has_competent" 
                    @on-change="toggleCompetent"
                    :is-active="isCompetent(has_competent)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton> 
              </td>
            </tr> 
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Senarai dan penerangan lengkap pengalaman kerja seperti yang dikehendaki dalam Bahagian D.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton 
                  class="float-right"
                    v-model="form.has_jobs_description" 
                    @on-change="toggleJobs"
                    :is-active="isJobs(has_jobs_description)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton> 
              </td>
            </tr>
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">
                <p>Senarai dan penerangan lengkap pengalaman kerja dan latihan berkaitan pengurusan tenaga elektrik</p>
                <p class="mt-4">dengan cekap seperti yang dikehendaki dalam Bahagian E(i),(ii),(iii)dan (iv).</p>
              </td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton 
                  class="float-right"
                    v-model="form.has_jobs_experience" 
                    @on-change="toggleExperienced"
                    :is-active="isExperienced(has_jobs_experience)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton> 
              </td>
            </tr> -->
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Surat pengesahan yang berkenaan daripada majikan/pihak pepasangan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <file-input v-if="!surat_pengesahan_upload" v-model="form.surat_pengesahan" :error="form.errors.surat_pengesahan" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Surat Pengesahan Majikan (pdf format)" /> 
              </td>
            </tr>             
          </table>
        </div>

        </tab-content>

        <tab-content title="Bahagian H : Pengakuan">

        <div class="flex items-center justify-between mt-6">
          <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
            ✒️ <span class="text-indigo-600">Pengesahan Pemohon</span>
          </h1>
        </div>

        <span style="width: 100%;" class="pb-16 pr-12 flex items-center" ref="status">
          <span class="text-xl px-8">Saya mengaku bahawa kenyataan diberikan di dalam borang ini dan dokumen yang disertakan adalah benar seperti yang dikehendaki dan ECoS berhak menolah permohonan ini jika didapati keterangan dan dokumen yang diberikan adalah tidak lengkap, tidak benar, palsu atau tidak disertakan butir-butir yang dikehendaki.</span>             
          <Vue3ToggleButton 
          class="float-right"
            v-model="form.is_declared" 
            @on-change="toggleStatus(is_declared)"
            :is-active="isDeclared(is_declared)" 
            :trackColor="'#ccc'" 
            :track-active-color="'#d9efe0'" 
            :handleColor="'#2f5a5b'"></Vue3ToggleButton> 
        </span> 


        </tab-content>

      </form-wizard>    
      
    </div>

    </form>
    
    <Modal @close="toggleCompetentPerson" :modalActive="modalCompetentPerson" @submit="updateCompetentPerson">
      <div class="mx-6 pb-4">
          <span class="group flex items-center py-3 mb-6">
            <icon name="profile" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Perakuan Kekompetenan Sedia Ada</h1>
            <button v-if="this.competent == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('competents', form.competent_id)">
              <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
            </button>
          </span>  
          <div class="flex flex-wrap mr-6 p-8">
            <text-input v-model="form.competent_name" :error="form.errors.competent_name" class="pb-8 pr-6 w-full" label="Perakuan Kekompeten" />
            <text-input v-model="form.competent_certificate" :error="form.errors.competent_certificate" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Perakuan " />
            <select-input v-model="form.competent_restriction" :error="form.errors.competent_restriction" class="pb-8 pr-6 w-full lg:w-1/2" label="Sekatan ">
                  <option :value="null" />
                  <option value="Terhad">Terhad</option>
                  <option value="Terbuka">Terbuka</option>
            </select-input> 
            <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.competent_cert_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Dikeluarkan"></Datepicker>
            <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen (pdf format)</th>
            </tr>
            <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-l border-t border-b pl-4">
                Salinan perakuan kekompetenan (Pengurus Tenaga)
              </td>
              <td class="border-t border-b border-r">
                <file-input v-model="form.competent_document_certificate" :error="form.errors.competent_document_certificate" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Perakuan kekompetenan - Pengurus Tenaga (pdf)" />
              </td>             
            </tr>
          </table>
          </div> 
      </div>    
    </Modal> 

    <Modal @close="toggleAcademics" :modalActive="modalAcademics" @submit="updateAcademics">
      <div class="mx-6">
          <span class="group flex items-center py-3 mb-6">
            <icon name="eligibility" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Kelayakan Akademik (Ijazah/Kelulusan yang setaraf)</h1>
            <button v-if="this.academic == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('academics', form.academic_id)">
              <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
            </button>
          </span>  
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.academic_name" :error="form.errors.academic_name" class="pb-8 pr-6 w-full" label="Nama Ijazah/Kelulusan yang setaraf " />
            <text-input v-model="form.academic_course" :error="form.errors.academic_course" class="pb-8 pr-6 w-full lg:w-1/2" label="Nama Institusi/Universiti " />
            <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.academic_cert_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Lulus"></Datepicker>

                <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
                  <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen (pdf format)</th>
                </tr>
                <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                  <td class="border-l border-t border-b pl-4">
                    Salinan Ijazah/kelulusan setaraf yang disahkan.
                  </td>
                  <td class="border-t border-b border-r pr-4">
                    <file-input v-model="form.academic_document_certificate" :error="form.errors.academic_document_certificate" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Salinan Ijazah / Kelulusan (pdf)" />
                  </td>             
                </tr>
              </table>                 

          </div> 
      </div>    
    </Modal> 

    <Modal @close="toggleExperiences" :modalActive="modalExperiences" @submit="updateExperiences">
      <div class="mx-6">
          <span class="group flex items-center py-3 mb-6">
            <icon name="experience" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Rekod Pengalaman Kerja Pemohon</h1>
            <button v-if="this.experience == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('experiences', form.experience_id)">
              <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
            </button>
          </span>  
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.experience_name" :error="form.errors.experience_name" class="pb-8 pr-6 w-full" label="Nama Majikan " />
            <text-input v-model="form.experience_address" :error="form.errors.experience_address" class="pb-8 pr-6 w-full" label="Alamat Majikan " />
            <text-input v-model="form.experience_position" :error="form.errors.experience_position" class="pb-8 pr-6 w-full" label="Jawatan yang disandang " />
            <text-input v-model="form.experience_jobs" :error="form.errors.experience_jobs" class="pb-8 pr-6 w-full" label="Bidang Tugas " />
            <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.experience_start_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Mula"></Datepicker>
              <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.experience_end_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Tamat"></Datepicker>
          </div> 
      </div>    
    </Modal> 

    <Modal @close="toggleCourses" :modalActive="modalCourses" @submit="updateCourses">
          <div class="mx-6">
              
              <span class="flex items-center py-3 mb-6">
                <icon name="eligibility" class="mr-4 w-8 h-8 text-gray-700"/>
                <h1 style="width: 100%;" class="text-2xl font-bold">Latihan/Kursus Berkaitan Kecekapan Tenaga Yang Pernah Disertai</h1>
                <button v-if="this.course == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('courses', form.course_id)">
                  <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
                </button>
              </span> 
              
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <text-input v-model="form.course_name" :error="form.errors.course_name" class="pb-8 pr-6 w-full" label="Nama Kursus " />
                <text-input v-model="form.course_scope" :error="form.errors.course_scope" class="pb-8 pr-6 w-full" label="Skop/Bidang Topik Kecekapan Tenaga " />
                <Datepicker 
                    class="pt-6 pb-6 pr-4 lg:w-1/2"  
                    v-model="form.course_year"
                    format="yyyy"
                    year-only=true
                    @closed="runme()"
                    placeholder="Tahun"></Datepicker>
                <text-input v-model="form.course_duration" :error="form.errors.course_duration" class="pb-8 pr-6 w-full lg:w-1/2" label="Tempoh Kursus " />
                <text-input v-model="form.course_organizer" :error="form.errors.course_organizer" class="pb-8 pr-6 w-full" label="Organisasi Penyelia Kursus " />
                <text-input v-model="form.course_others" :error="form.errors.course_others" class="pb-8 pr-6 w-full" label="Lain-lain Organisasi " />
              </div> 
          </div>    
        </Modal>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Layout from '@/Shared/Layout'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import {FormWizard, TabContent} from 'vue3-form-wizard'
import '../../../../node_modules/vue3-form-wizard/dist/style.css'
//import '../../../../node_modules/vue-form-wizard/dist/vue-form-wizard.js'
import Icon from '@/Shared/Icon'
import Modal from "@/Shared/Modal.vue"
import axios from 'axios'
import AvatarInput from '@/Shared/AvatarInput'
import { Vue3ToggleButton } from 'vue3-toggle-button'
import '../../../../node_modules/vue3-toggle-button/dist/style.css'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    FileInput,
    FormWizard,
    AvatarInput,
    TabContent,
    Modal,
    Icon,
    Vue3ToggleButton,
    Datepicker,
  },
  setup() {
    const modalCompetentPerson = ref(false);
    const modalAcademics = ref(false);
    const modalExperiences = ref(false);
    const modalCourses = ref(false);

    const toggleAcademics = () => {
      modalAcademics.value = !modalAcademics.value;
    };

    const toggleCompetentPerson = () => {
      modalCompetentPerson.value = !modalCompetentPerson.value;
    };

    const toggleExperiences = () => {
      modalExperiences.value = !modalExperiences.value;
    };

    const toggleCourses = () => {
      modalCourses.value = !modalCourses.value;
    };

    return { modalAcademics, toggleAcademics, 
             modalCompetentPerson, toggleCompetentPerson, 
             modalExperiences, toggleExperiences,
             modalCourses, toggleCourses};
  },  
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        photo: null,
        category: null,
        name: null,
        ic_no: null,
        ic_copy: null,
        id_no: null,
        type: null,
        birthday: null,
        gender: null,
        address: null,
        city: null,
        postal_code: null,
        region: null,
        mail_address: null,
        mail_city: null,
        mail_poscode: null,
        mail_state: null,
        phone_no: null,
        phone: null,
        email: null,
        company_name: null,
        company_address: null,
        company_city: null,
        company_poscode: null,
        company_state: null,
        company_phone: null,
        company_fax: null,
        website: null,
        position: null,
        my_engineering_register: null,
        my_engineering_register: null,
        field_knowledge: null,
        academic_id: null, //*Form Fields*
        academic_name: null, //*Form Fields*
        academic_course: null, //*Form Fields*
        academic_cert_date: null, //*Form Fields*
        academic_document_certificate: null,
        competent_id: null, 
        competent_name: null, 
        competent_certificate: null,
        competent_document_certificate: null,
        competent_restriction: null,
        competent_cert_date: null,
        experience_id: null, 
        experience_name: null, 
        experience_address: null, 
        experience_position: null, 
        experience_jobs: null,
        experience_start_date: null,
        experience_end_date: null,
        course_id: null, 
        course_name: null, 
        course_course: null, 
        course_scope: null, 
        course_year: null, 
        course_duration: null, 
        course_organization: null, 
        course_others: null,
        referral_name: null,
        referral_organization: null,
        referral_position: null,
        referral_phone: null,
        referral_fax: null,
        referral_email: null,
        lampiran_a: null,
        resit_pembayaran: null,
        passport_photo: null,
        surat_pengesahan: null,
        is_mailing: false,
        is_declared: false,
        is_acknowledged: false,
        is_paid: false,
        has_photos: false,
        has_id: false,
        has_qualification: false,
        has_competent: false,
        has_jobs_description: false,
        has_jobs_experience: false,
        has_employer_acknowledged: false,
        date_declared: null,
        employer_attachment: false,
        date_acknowledged: null,
        employer_name: false,
        employer_position: false
      }),
      managers_id: "draft", //Interim REEM ID
      competent: "", 
      competents:[], 
      academic: "",  // Object Action
      academics: [], // Object Array List
      experience: "",  // Object Action
      experiences: [], // Object Array List
      course: "",  // Object Action
      courses: [], // Object Array List
    }
  },
  props: {
      photo: String,
    },
  mounted(){ 

  },
  methods: {
    store() {

      let is_declared = "disagree"
      let is_paid="unpaid"
      let has_photos="unattached"
      let has_id="unattached"
      let has_qualification="unattached"
      let has_competent="unattached"
      let has_jobs_description="unattached"
      let has_jobs_experience="unattached"
      let has_employer_acknowledged="unattached"

      if(this.form.is_declared)is_declared = "agree"
      if(this.form.is_paid)is_paid = "paid"
      if(this.form.has_photos)has_photos = "attached"
      if(this.form.has_id)has_id = "attached"
      if(this.form.has_qualification)has_qualification = "attached"
      if(this.form.has_competent)has_competent = "attached"
      if(this.form.has_jobs_description)has_jobs_description = "attached"
      if(this.form.has_jobs_experience)has_jobs_experience = "attached"
      if(this.form.has_employer_acknowledged)has_employer_acknowledged = "attached"

      const formData = new FormData();
      formData.append('managers_id',this.managers_id);
      formData.append('category',this.form.category);
      formData.append('photo',this.form.photo);
      formData.append('name',this.form.name);
      formData.append('ic_no',this.form.ic_no);
      formData.append('ic_copy',this.form.ic_copy);
      formData.append('id_no',this.form.id_no);
      formData.append('type',this.form.type);
      formData.append('birthday',this.form.birthday);
      formData.append('gender',this.form.gender);
      formData.append('address',this.form.address);
      formData.append('city',this.form.city);
      formData.append('postal_code',this.form.postal_code);
      formData.append('region',this.form.region);
      formData.append('mail_address',this.form.mail_address);
      formData.append('mail_city',this.form.mail_city);
      formData.append('mail_poscode',this.form.mail_poscode);
      formData.append('mail_state',this.form.mail_state);
      formData.append('phone_no',this.form.phone_no);
      formData.append('phone',this.form.phone);
      formData.append('email',this.form.email);
      formData.append('company_name',this.form.company_name);
      formData.append('company_address',this.form.company_address);
      formData.append('company_city',this.form.company_city);
      formData.append('my_engineering_register',this.form.my_engineering_register);
      formData.append('my_engineering_reff',this.form.my_engineering_reff);
      formData.append('field_knowledge',this.form.field_knowledge);
      formData.append('company_poscode',this.form.company_poscode);
      formData.append('company_state',this.form.company_state);
      formData.append('company_phone',this.form.company_phone);
      formData.append('company_fax',this.form.company_fax);
      formData.append('website',this.form.website);
      formData.append('position',this.form.position);
      formData.append('is_declared',is_declared);     
      formData.append('has_fees',is_paid);
      formData.append('has_photos',has_photos);
      formData.append('has_id',has_id);
      formData.append('has_qualification',has_qualification);
      formData.append('has_competent',has_competent);
      formData.append('has_jobs_description',has_jobs_description);
      formData.append('has_jobs_experience',has_jobs_experience);
      formData.append('has_employer_acknowledged',has_employer_acknowledged);
      formData.append('referral_name',this.form.referral_name);
      formData.append('referral_organization',this.form.referral_organization);
      formData.append('referral_position',this.form.referral_position);
      formData.append('referral_phone',this.form.referral_phone);
      formData.append('referral_fax',this.form.referral_fax);
      formData.append('referral_email',this.form.referral_email);
      formData.append('lampiran_a',this.form.lampiran_a);
      formData.append('resit_pembayaran',this.form.resit_pembayaran);
      formData.append('passport_photo',this.form.passport_photo);
      formData.append('surat_pengesahan',this.form.surat_pengesahan);
      
      axios.post(`/reem`, formData)
          .then(response => {

            if(response.data.status === 'success'){
              this.managers_id = response.data.managers_id;
              
              if(this.competents.length>0){
                this.competents.forEach((competent) => {
                  const formData = new FormData();
                  formData.append('managers_id', this.managers_id);
                  formData.append('competent', "create");
                  formData.append('competent_name', competent.name);
                  formData.append('competent_certificate', competent.certificate);
                  formData.append('competent_restriction', competent.restriction);
                  formData.append('competent_cert_date', competent.cert_date);
                  formData.append('competent_document_certificate', competent.competent_document_certificate);
                  axios.post(`/reem/${this.managers_id}/competents`, formData).then(response => {}).catch(error => { });
                }); 
              }

              if(this.academics.length>0){
                this.academics.forEach((academic) => {
                  const formData = new FormData();
                  formData.append('managers_id', this.managers_id);
                  formData.append('academic', "create");
                  formData.append('academic_name', academic.name);
                  formData.append('academic_course', academic.course);
                  formData.append('academic_cert_date', academic.cert_date);
                  formData.append('academic_document_certificate', academic.academic_document_certificate);
                  axios.post(`/reem/${this.managers_id}/academics`, formData).then(response => {}).catch(error => { }); 
                });
              }

              if(this.experiences.length>0){
                this.experiences.forEach((experience) => {
                  const formData = new FormData();
                  formData.append('managers_id', this.managers_id);
                  formData.append('experience', "create");
                  formData.append('experience_name', experience.name);
                  formData.append('experience_address', experience.address);
                  formData.append('experience_position', experience.position);
                  formData.append('experience_jobs', experience.jobs);
                  formData.append('experience_start_date', experience.start_date);
                  formData.append('experience_end_date', experience.end_date);
                  axios.post(`/reem/${this.managers_id}/experiences`, formData).then(response => {}).catch(error => { }); 
                }); 
              }

              if(this.courses.length>0){
                this.courses.forEach((course) => {
                  const formData = new FormData();
                  formData.append('managers_id', this.managers_id);
                  formData.append('course', "create");
                  formData.append('course_name', course.name);
                  formData.append('course_scope', course.scope);
                  formData.append('course_course', course.course);
                  formData.append('course_year', course.year);
                  formData.append('course_duration', course.course_duration);
                  formData.append('course_organizer', course.organizer);
                  formData.append('course_others', course.others);
                  axios.post(`/reem/${this.managers_id}/courses`, formData).then(response => {}).catch(error => { }); 
                }); 
              }              
              
              this.$page.props.flash.success = response.data.message

            }
          })
          .catch(error => { });

      
    },
    async mediaUploaded(e){    
      this.media = JSON.parse(JSON.stringify(e));
    },
    onComplete(){      
      alert("Form Complete!");
      this.store();
    },
    loadAcademic(academic){
      this.academic = "update";
      this.form.academic_id = academic.id;
      this.form.academic_name = academic.name;
      this.form.academic_course = academic.course;
      this.form.academic_cert_date = academic.cert_date;
      this.form.academic_document_certificate = academic.academic_document_certificate,
      this.toggleAcademics()
    },
    formAcedemics(){
      this.academic = "create";
      this.form.academic_id = "";
      this.form.academic_name = "";
      this.form.academic_course = "";
      this.form.academic_cert_date = "";
      this.form.academic_document_certificate = "";
      this.toggleAcademics()
    },
    updateAcademics(){
      if(this.academic == "create"){
        this.form.academic_id = Math.floor(new Date().valueOf() * Math.random());
        this.academics.push({id:this.form.academic_id,
                           name:this.form.academic_name,
                           course: this.form.academic_course,
                           cert_date: this.form.academic_cert_date,
                           academic_document_certificate : this.form.academic_document_certificate,
                          });
      }else{
        this.academics.forEach((academic) => {
          if(academic.id == this.form.academic_id){
            academic.name = this.form.academic_name;
            academic.course = this.form.academic_course;
            academic.cert_date = this.form.academic_cert_date;
            academic.academic_document_certificate = this.form.academic_document_certificate;
          }  
        }); 
      }
      this.toggleAcademics()
    },
    loadCompetent(competent){
      this.competent = "update";
      this.form.competent_id = competent.id;
      this.form.competent_name = competent.name;
      this.form.competent_certificate = competent.certificate;
      this.form.competent_restriction = competent.restriction;
      this.form.competent_cert_date = competent.cert_date;
      this.form.competent_document_certificate = competent.competent_document_certificate,
      this.toggleCompetentPerson()
    },
    formCompetentPerson(){
      this.competent = "create";
      this.form.competent_id = "";
      this.form.competent_name = "";
      this.form.competent_certificate = "";
      this.form.competent_restriction = "";
      this.form.competent_cert_date = "";
      this.form.competent_document_certificate = "";
      this.toggleCompetentPerson()
    },
    updateCompetentPerson(){
      if(this.competent == "create"){
        this.form.competent_id = Math.floor(new Date().valueOf() * Math.random());
        this.competents.push({id:this.form.competent_id,
                              name:this.form.competent_name,
                              certificate: this.form.competent_certificate,
                              restriction: this.form.competent_restriction,
                              cert_date: this.form.competent_cert_date,
                              competent_document_certificate : this.form.competent_document_certificate,
                          });
      }else{
        this.competents.forEach((competent) => {
          if(competent.id == this.form.competent_id){
            competent.name = this.form.competent_name;
            competent.certificate = this.form.competent_certificate;
            competent.restriction = this.form.competent_restriction;
            competent.cert_date = this.form.competent_cert_date;
            competent.competent_document_certificate = this.form.competent_document_certificate;
          }  
        }); 
      }
      this.toggleCompetentPerson()
    },
    loadExperience(experience){
      this.experience = "update";
      this.form.experience_id = experience.id;
      this.form.experience_name = experience.name;
      this.form.experience_address = experience.address;
      this.form.experience_position = experience.position;
      this.form.experience_jobs = experience.jobs;
      this.form.experience_start_date = experience.start_date;
      this.form.experience_end_date = experience.end_date;
      this.toggleExperiences()
    },
    formExperiences(){
      this.experience = "create";
      this.form.experience_id = "";
      this.form.experience_name = "";
      this.form.experience_address = "";
      this.form.experience_position = "";
      this.form.experience_jobs = "";
      this.form.experience_start_date = "";
      this.form.experience_end_date = "";
      this.toggleExperiences()
    },
    updateExperiences(){
      if(this.experience == "create"){
        this.form.experience_id = Math.floor(new Date().valueOf() * Math.random());
        this.experiences.push({id:this.form.experience_id,
                         name:this.form.experience_name,
                         address:this.form.experience_address,
                         position:this.form.experience_position,
                        jobs:this.form.experience_jobs,
                       start_date:this.form.experience_start_date,
                         end_date:this.form.experience_end_date,
                          });
      }else{
        this.experiences.forEach((experience) => {
          if(experience.id == this.form.experience_id){
            experience.name = this.form.experience_name;
            experience.address = this.form.experience_address;
            experience.position = this.form.experience_position; 
            experience.jobs = this.form.experience_jobs; 
            experience.start_date = this.form.experience_start_date; 
            experience.end_date = this.form.experience_end_date;
          }  
        }); 
      }
      this.toggleExperiences()
    },
    loadCourses(course){
      this.course = "update";
      this.form.course_id = course.id;
      this.form.course_name = course.name;
      this.form.course_scope = course.scope;
      this.form.course_year = course.year;
      this.form.course_duration = course.duration;
      this.form.course_organizer = course.organizer;
      this.form.course_others = course.others;
      this.toggleCourses()
    },
    formCourses(){
      this.course = "create";
      this.form.course_id = "";
      this.form.course_name = "";
      this.form.course_scope = "";
      this.form.course_year = "";
      this.form.course_duration = "";
      this.form.course_organizer = "";
      this.form.course_others = "";
      this.toggleCourses()
    },
    updateCourses(){
      
      if(this.course == "create"){
        this.form.course_id = Math.floor(new Date().valueOf() * Math.random());
        this.courses.push({id:this.form.course_id,
                          name:this.form.course_name,
                          course: this.form.course_course,
                          scope: this.form.course_scope,
                          year: moment(this.form.course_year).format("yyyy"),
                          duration: this.form.course_duration,
                          organizer: this.form.course_organizer,
                          others: this.form.course_others,
                          });
      }else{
        this.courses.forEach((course) => {
          if(course.id == this.form.course_id){
              course.name = this.form.course_name;
              course.course = this.form.course_course;
              course.scope = this.form.course_scope;
              course.year = moment(this.form.course_year).format("yyyy");
              course.duration = this.form.course_duration;
              course.organizer = this.form.course_organizer;
              course.others = this.form.course_others;
          }  
        }); 
      }
      
      this.toggleCourses()
    },    
    runme(){

    },
    isDeclared(status){
      let stat = false;
      if(status == 'agree')stat = true;
      return stat;      
    },
    isAcknowledged(status){
      let stat = false;
      if(status == 'acknowledge')stat = true;
      return stat;      
    },
    isPaid(status){
      let stat = false;
      if(status)stat = true;
      return stat; 
    },
    isPhoto(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isIdentified(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isQualified(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isCompetent(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isJobs(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isExperienced(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isEmployeer(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    togglePay(){
      if(!this.form.is_paid){
        this.form.is_paid = true
      }else{
        this.form.is_paid = false
      }   
    },
    togglePhoto(){
      if(!this.form.has_photos){
        this.form.has_photos = true
      }else{
        this.form.has_photos = false
      }   
    },
    toggleIdentified(){
      if(!this.form.has_id){
        this.form.has_id = true
      }else{
        this.form.has_id = false
      }  
    },
    toggleQualification(){
      if(!this.form.has_qualification){
        this.form.has_qualification = true
      }else{
        this.form.has_qualification = false
      }  
    },
    toggleCompetent(){
      if(!this.form.has_competent){
        this.form.has_competent = true
      }else{
        this.form.has_competent = false
      }  
    },
    toggleJobs(){
      if(!this.form.has_jobs_description){
        this.form.has_jobs_description = true
      }else{
        this.form.has_jobs_description = false
      }  
    },
    toggleExperienced(){
      if(!this.form.has_jobs_experience){
        this.form.has_jobs_experience = true
      }else{
        this.form.has_jobs_experience = false
      } 
    },
    toggleEmployeer(){
      if(!this.form.has_employer_acknowledged){
        this.form.has_employer_acknowledged = true
      }else{
        this.form.has_employer_acknowledged = false
      } 
    },    
    toggleStatus(){
      if(!this.form.is_declared){
        this.form.is_declared = true
      }else{
        this.form.is_declared = false
      } 
    },
    removeRecord(target, item){
      if (confirm('Are you sure you want to remove this record?')) {
                
            if(target=="competents"){
              this.competents = this.competents.filter(competent => !(competent.id == item));
              this.toggleCompetentPerson()
            }
            if(target=="academics"){
              this.academics = this.academics.filter(academic => !(academic.id == item));
              this.toggleAcademics()
            }
            if(target=="experiences"){
              this.experiences = this.experiences.filter(experience => !(experience.id == item));
              this.toggleExperiences()
            }
            if(target=="courses"){
              this.courses = this.courses.filter(course => !(course.id == item));
              this.toggleCourses()
            }    
          
        }
    },            
  },
}
</script>
